import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { RouterModule } from '@angular/router'
import { configuratorFactoryRoutes } from './configurator-factory.routes'
import { UiModule } from '../../../../ui/monolith/ui.module'
import { CheckoutUiModule } from '../ui/checkout-ui.module'
import { DealUiModule } from '../../ui/deal-ui.module'
import { MatButtonModule } from '@angular/material/button'
import { MatCheckboxModule } from '@angular/material/checkbox'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatIconModule } from '@angular/material/icon'
import { MatInputModule } from '@angular/material/input'
import { MatProgressBarModule } from '@angular/material/progress-bar'
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner'
import { MatSelectModule } from '@angular/material/select'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { OptionsComponent } from './containers/options/options.component'
import { CelebrateComponent } from './containers/celebrate/celebrate.component'
import { LayoutComponent } from './containers/layout/layout.component'
import { ConfirmComponent } from './containers/confirm/confirm.component'
import { NeedloginGuard } from './guards/needlogin.guard'
import { ConfigurationIdResolver } from './resolvers/configurationId.resolver'
import { BasePathResolver } from '../../../../framework/module-base-path/basePath.resolver'
import { ConfigurationRouteService } from './services/configurationRoute.service'
import { CheckoutFactoryComponentsModule } from './components/checkout-factory-components.module'
import { StepDatalayerGuard } from './guards/step-datalayer.guard'
import { BannerModule } from '../../../../ui/banners/banner/banner.module'
import { ConfigurationAnalyticsService } from './services/configurationAnalytics.service'
import { RouteWildcardResolver } from 'framework/route-wildcard-resolver/route-wildcard.resolver'

@NgModule({
    imports: [
        CommonModule,
        RouterModule.forChild(configuratorFactoryRoutes),
        UiModule,
        CheckoutUiModule,
        DealUiModule,
        MatProgressBarModule,
        MatCheckboxModule,
        MatCheckboxModule,
        MatButtonModule,
        MatIconModule,
        MatFormFieldModule,
        MatInputModule,
        FormsModule,
        MatSelectModule,
        ReactiveFormsModule,
        MatProgressBarModule,
        MatProgressSpinnerModule,
        DealUiModule,
        CheckoutFactoryComponentsModule,
        BannerModule,
    ],
    declarations: [LayoutComponent, ConfirmComponent, CelebrateComponent, OptionsComponent],
    providers: [
        ConfigurationAnalyticsService,
        ConfigurationIdResolver,
        BasePathResolver,
        NeedloginGuard,
        StepDatalayerGuard,
        ConfigurationRouteService,
        RouteWildcardResolver,
    ],
})
export class ConfiguratorFactoryModule {}
